/**
 * BLOCK: navbar
 */
import NavOverlay from "./scripts-NavOverlay.jsx";

jQuery(document).ready(function ($) {
  window.$ = $;

  class LutherNavbar {
    constructor() {
      this.navbar = document.querySelector(".page-navbar");

      this.Overlay = new NavOverlay(this.navbar);
    }
  }

  window.luther = window.luther || {};
  window.luther.navbar = new LutherNavbar();
});
